import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Button } from '../../../../common/html/button'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import EventEmitter from '../../../../helpers/EventEmitter'
import { SHOW_POPUP_BUSINESS_CONCIERGE } from '../../businessConciergeService/PopupBusinessConcierge'
import { resetCompany } from '../../preview/store/slice'
import classes from './index.module.scss'

export const CreateRequestBlock = () => {
  const dispatch = useDispatch()

  const onClick = () => {
    dispatch(resetCompany())
    EventEmitter.dispatch(
      SHOW_POPUP_BUSINESS_CONCIERGE,
      'internationalSearch.BUSINESS_CONCIERGE_SERVICE',
    )
  }

  return (
    <Element
      className={['p2', classes.blockContainer].join(' ')}
      style={{ backgroundColor: '#fff' }}
    >
      <div className="dFlex alignItemsCenter mb2">
        <Element
          className={[
            'dFlex alignItemsCenter justifyContentCenter',
            classes.blockIcon,
          ].join(' ')}
          style={{ backgroundColor: '#2C73E8' }}
        >
          <Icon
            className="icon-key cursorDefault"
            style={{ fontSize: 12, color: '#fff' }}
          />
        </Element>
        <Element
          elementName="span"
          className="fw600 ml1"
          style={{ color: '#191D25', fontSize: 14 }}
        >
          <Translate value="internationalSearch.NEED_TO_DIG" />
        </Element>
      </div>
      <Element style={{ color: '#3A414B', lineHeight: 1.6 }} className="mb2">
        <Translate value="internationalSearch.OUR_BUSINESS" />
      </Element>
      <div className="dFlex justifyContentEnd">
        <Button
          isI18n={true}
          label="internationalSearch.CREATE_REQUEST"
          style={{ fontSize: 12, color: '#fff', backgroundColor: '#2c73e8' }}
          className={classes.buttonCreateRequest}
          action={onClick}
        />
      </div>
    </Element>
  )
}
